<div [class]="showCustomButtonBar ? 'grid' : ''">
  <div [class]="showCustomButtonBar ? 'col-12 md:col-6' : ''">
    <div class="block mb-1">
      <label *ngIf="!isH3Title && !isDivTitle"
        ><span *ngIf="requiredStar" class="requiredStar">*</span
        >{{ title | translate }}</label
      >
      <div *ngIf="isDivTitle" class="font-bold">
        <span *ngIf="requiredStar" class="requiredStar">*</span
        >{{ title | translate }}
      </div>
      <h3 *ngIf="isH3Title && title && title != ''" class="font-bold mt-0 mb-2">
        <span *ngIf="requiredStar" class="requiredStar">*</span
        >{{ title | translate }}
      </h3>
    </div>
    <div class="block mb-1">
      <div class="calendar-wrapper">
      <input
        #manualInput
        pInputText
        class="w-full display-input"
        [value]="displayValue"
        [readonly]="!enableManualInput"
        (blur)="enableManualInput ? onManualInput($event) : null"
        (keydown.enter)="enableManualInput ? onManualInput($event) : null"
        (click)="openCalendar()"
      />
        <p-calendar
          #calendar
          placeholder="{{ placeholder | translate }}"
          [selectionMode]="calendarMode === 'Range' ? 'range' : 'single'"
          [ngModel]="date"
          [ngModelOptions]="{ standalone: true }"
          [readonlyInput]="readonlyInput"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [showTime]="false"
          [showSeconds]="showSeconds"
          (onSelect)="onCalendarSelect($event)"
          (onClose)="onCalendarClose()"
          [dateFormat]="dateFormat"
          class="calendar-proxy"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="2020:2030"
          [appendTo]="'body'"
          [showTransitionOptions]="'0ms'"
          [hideTransitionOptions]="'0ms'"
          [inputStyle]="{'height': '0px', 'border': 'none', 'padding': '0'}"
        >
        <p-footer class="custom-footer">
          <div class="footer-top" *ngIf= "showCustomTime">
            <laas-time-slider
              [value]="getTimeSliderValue()"
              (valueChange)="onTimeSliderValueChange($event)"
              [showSeconds]="showSeconds"
            >
            </laas-time-slider>
          </div>
            <div class="footer-bottom">
              <button
                pButton
                class="p-button-secondary"
                label="{{ 'Common.Button.Clean' | translate }}"
                (click)="clearDate()"
              ></button>
                <div *ngIf="selectionMode === 'range'" class="date-range">
                  <span *ngIf="showDate">
                    ({{ 'Common.Button.Start' | translate }})
                    {{ showDate[0] | date : datePipeDateFormat }}
                    -
                    ({{ 'Common.Button.End' | translate }})
                    {{ showDate[1] | date : datePipeDateFormat }}
                  </span>
                  <span *ngIf="!showDate">
                    ({{ 'Common.Button.Start' | translate }}) -
                    ({{ 'Common.Button.End' | translate }})
                  </span>
                </div>
            </div>
        </p-footer>
        </p-calendar>
      </div>
    </div>
    <ng-container *ngIf="showRangeMode || showStartMode || showEndMode">
      <div class="block">
        <div class="formgroup-inline mb-3">
          <div class="field-radiobutton">
            <p-radioButton
              *ngIf="showRangeMode"
              [(ngModel)]="calendarMode"
              value="Range"
              label="{{ 'Common.Button.Range' | translate }}"
              (onClick)="changeCalendarMode($event)"
            >
            </p-radioButton>
          </div>
          <div class="field-radiobutton">
            <p-radioButton
              *ngIf="showStartMode"
              [(ngModel)]="calendarMode"
              value="Start"
              label="{{ 'Common.Button.Start' | translate }}"
              (onClick)="changeCalendarMode($event)"
            >
            </p-radioButton>
          </div>
          <div class="field-radiobutton">
            <p-radioButton
              *ngIf="showEndMode"
              [(ngModel)]="calendarMode"
              value="End"
              label="{{ 'Common.Button.End' | translate }}"
              (onClick)="changeCalendarMode($event)"
            >
            </p-radioButton>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="showCustomButtonBar">
    <ng-container *ngIf="calendarMode === 'Range'">
      <div [class]="'col-12 md:col-6 align-content-end'">
        <div class="grid mt-1">
          <div class="col-12 md:col-4 my-1">
            <button
              pButton
              label="{{ 'Common.Button.Today' | translate }}"
              (click)="changeDate($event, 1)"
            ></button>
          </div>
          <div class="col-12 md:col-4 my-1">
            <button
              pButton
              label="{{ 'Common.Button.ThisWeek' | translate }}"
              (click)="changeDate($event, 2)"
            ></button>
          </div>
          <div class="col-12 md:col-4 my-1">
            <button
              pButton
              label="{{ 'Common.Button.ThreeDaysBefore' | translate }}"
              (click)="changeDate($event, 3)"
            ></button>
          </div>
          <div class="col-12 md:col-4 my-1">
            <button
              pButton
              label="{{ 'Common.Button.OneWeekBefore' | translate }}"
              (click)="changeDate($event, 4)"
            ></button>
          </div>
          <div class="col-12 md:col-4 my-1">
            <button
              pButton
              label="{{ 'Common.Button.TwoWeeksBefore' | translate }}"
              (click)="changeDate($event, 5)"
            ></button>
          </div>
          <div class="col-12 md:col-4 my-1">
            <button
              pButton
              label="{{ 'Common.Button.OneMonthBefore' | translate }}"
              (click)="changeDate($event, 6)"
            ></button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
